export default "__VITE_ASSET__DeL0sibX__"